import {useEffect, useMemo, useState, useContext} from "react";
import {Link} from "react-router-dom";
import Pagination from "../../components/Pagination";
import Phylotree from "../../components/Phylotree";
import '../../styles/pages/geneFamilies_overview.scss'
import geneFamilyIcon from '../../assets/images/icn-gene-family.png'
// import { useCookies } from "react-cookie";
import fetchOptionsBuilder from "../../fetchOptionBuilder";
import WorkflowContext from "../../workflowContext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);

  }

export default function GeneOverview() {
    // const [cookies, setCookie, removeCookie] = useCookies(['auth', 'userid']);
    const workflow = useContext(WorkflowContext);
    const [currentPage, setCurrentPage] = useState(null);
    const [pageSize, setPageSize] = useState(10);
    const [geneData, setGeneData] = useState([]);
    const [geneTerm, setGeneTerm] = useState('');
    const [sortBy, setSortBy] = useState(0);
    const [sortDir, setSortDir] = useState([0,0,0]);
    const [selectedGene, setSelectedGene] = useState(null);
    const [selectedGeneData, setSelectedGeneData] = useState(null);

    const headerMap = {
        'Gene': 'gene_name',
        'Cluster': 'cluster_id',
        'Function': 'gene_product',
    }
    const tableHeaders = Object.keys(headerMap);

    const filteredGeneData = geneData.filter(gene => (
        gene?.cluster_id?.toLowerCase().includes(geneTerm.toLowerCase()) ||
        gene?.gene_name?.toLowerCase().includes(geneTerm.toLowerCase()) ||
        gene?.gene_product?.toLowerCase().includes(geneTerm.toLowerCase())
    ))
    filteredGeneData.sort((a, b) => {
        if (!a[headerMap[tableHeaders[sortBy]]] && !b[headerMap[tableHeaders[sortBy]]]) return 0;
        if (!a[headerMap[tableHeaders[sortBy]]]) return 1;
        if (!b[headerMap[tableHeaders[sortBy]]]) return -1;
        const x = String(a[headerMap[tableHeaders[sortBy]]]).localeCompare(String(b[headerMap[tableHeaders[sortBy]]]));
        return sortDir[sortBy] ? -x : x;
    })

    const [apitoken, setApitoken] = useState(             // eslint-disable-line no-unused-vars
        getSessionStorageOrDefault('apitoken', null)
    );

    const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));  

    useEffect(() => {
        //get strain data for the table
        fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + "clusters/json", fetchOptionsBuilder(apitoken, workflow, getDataUserId))
            .then(response => response.json())
            .then(data => {
                setGeneData(data);
                setCurrentPage(1);
            });
    }, [workflow, apitoken, getDataUserId]);

    useEffect(() => {
        document.title = `Gene Families | Palmona Pathogenomics`
    }, []);

    useEffect(() => {
        if (!selectedGene) return;
        fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + `clusters/${selectedGene.cluster_id}/genes/json`, fetchOptionsBuilder(apitoken, workflow, getDataUserId))
            .then(response => response.json())
            .then(data => {
                setSelectedGeneData(data)
            });
    }, [selectedGene])

    // const renderTableRow = (data, isPreview) => {
    //     if (isPreview) {
    //         //is a cluster preview table cell
    //     return (
    //         <tr>
    //             <td>{data.gene_id}</td>
    //             <td>{data.gene_product}</td>
    //         </tr>
    //     );
    //     } else {
    //         return (
    //             <tr>
    //                 <td id="td-gene">{data.gene_name}</td>
    //                 <td id="td-cluster"><a onClick={() => selectGene(data.cluster_id)}>{data.cluster_id}</a></td>
    //                 <td id="td-function">{data.gene_product}</td>
    //             </tr>
    //         );
    //     }
    // }

    const currentTableData = useMemo(() => {
        const firstPageIndex = (parseInt(currentPage) - 1) * parseInt(pageSize);
        const lastPageIndex = parseInt(firstPageIndex) + parseInt(pageSize);
        return filteredGeneData.slice(parseInt(firstPageIndex), parseInt(lastPageIndex));
    }, [currentPage, pageSize, filteredGeneData]);

    const handleSelectionChange = (e) => {
        const parsedNum = parseInt(e.target.value)
        setPageSize(parsedNum)
    };

    const changeSort = col => {
        setSortBy(col);
        const newSortDir = [...sortDir];
        newSortDir[col] = 1 - sortDir[col];
        setSortDir(newSortDir);
    }

    return (
        <div className="screen geneFamilies overview">
            <div className="container mt-4 text-secondary">
                <div className="row align-items-start">
                    <div className="col-10 col-md-7 left">
                        <div className="header">
                            <h1>Gene Families Overview</h1>
                            <hr/>
                            <h2>Table of Gene Families</h2>
                            {/* <div className="subrow">
                                <div className="box1">
                                    <p>Entries per page:</p>
                                    <div className="select-wrap">
                                        <select name="countPerPage" id="countPerPage" onChange={handleSelectionChange}>
                                            <option value="10">10</option>
                                            {filteredGeneData.length > 10 && <option value="20">20</option>}
                                            {filteredGeneData.length > 20 && <option value="30">30</option>}
                                            {filteredGeneData.length > 30 && <option value="40">40</option>}
                                            {filteredGeneData.length > 40 && <option value="50">50</option>}
                                        </select>
                                        <span>Viewing {((currentPage - 1) * pageSize) + 1} to {(currentPage * pageSize) > filteredGeneData.length ? filteredGeneData.length : (currentPage * pageSize)} of {filteredGeneData.length} entries</span>
                                    </div>
                                </div>
                                <input type="search" name="searchRows" id="searchRows" placeholder="Search" onChange={(e) => setGeneTerm(e.target.value)} />
                            </div> */}
                        </div>
                        {/* <table className="table">
                            <thead className="thead-dark">
                            <tr>
                                <th id="th-gene" scope="col" className={sortBy === 0 ? 'sort' : 'nosort'} onClick={() => changeSort(0)}>{tableHeaders[0]} {sortDir[0] ? '▲' : '▼'}</th>
                                <th id="th-cluster" scope="col" className={sortBy === 1 ? 'sort' : 'nosort'} onClick={() => changeSort(1)}>{tableHeaders[1]} {sortDir[1] ? '▲' : '▼'}</th>
                                <th id="th-function" scope="col" className={sortBy === 2 ? 'sort' : 'nosort'} onClick={() => changeSort(2)}>{tableHeaders[2]} {sortDir[2] ? '▲' : '▼'}</th>
                            </tr>
                            </thead>
                            <tbody>
                                {currentTableData.map((data) => renderTableRow(data))}
                            </tbody>
                        </table>
                        <Pagination
                            className="pagination-bar"
                            currentPage={currentPage}
                            totalCount={filteredGeneData.length}
                            pageSize={pageSize}
                            onPageChange={page => setCurrentPage(page)}
                        /> */}
                        <DataTable value={geneData} paginator rows={10} rowsPerPageOptions={[5, 10, 25, 50]} sortField="gene_name" sortOrder={1} selectionMode="single" selection={selectedGene} onSelectionChange={e => setSelectedGene(e.value)}>
                            <Column field="gene_name" header="Name" sortable filter/>
                            <Column field="cluster_id" header="Cluster" sortable filter/>
                            <Column field="gene_product" header="Function" sortable filter/>
                        </DataTable>
                    </div>
                    <div className="col-6 col-md-5 right">
                        <h2>Cluster Preview</h2>
                        {selectedGeneData ? <div className="box-wrap">
                            <h2>{selectedGene.cluster_id}</h2>
                            <div className="detail-box">
                                <div className="left-bx">
                                    <img src={geneFamilyIcon} alt="icon" />
                                </div>
                                <div className="right-bx">
                                    <h2>{selectedGeneData.length}</h2>
                                    <h5>Strains found</h5>
                                    <Link id='link' to={`detail/${selectedGene.cluster_id}`}>See more</Link>
                                </div>
                            </div>
                            <div className="phylotree-box">
                                <h3>Phylotree</h3>
                                <Phylotree id={selectedGene}/>
                            </div>
                        </div>:
                            <p className="none-selected">None Selected</p>}
                    </div>
                </div>
            </div>
        </div>
    );
}
